(function () {
    'use strict';
    angular.module('Directives').directive('bbaTabs', bbaTabs);
    bbaTabs.$inject = ['$timeout'];
    function bbaTabs($timeout) {
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/bba-tabs.html',
            replace: true,
            scope: {},
            controller: bbaTabsController,
            transclude: true,
        }

        function bbaTabsController($scope) {
            const panes = $scope.panes = [];

            init();

            function init() {
                setDefaultSelectedTabl();
            }

            function setDefaultSelectedTabl() {
                $timeout(() => {
                    if (panes.length > 0) {
                        $scope.select(panes[0]);
                    }
                }, 500);
            }

            $scope.select = function (pane) {
                angular.forEach(panes, function (p) {
                    p.selected = false;
                });
                pane.selected = true;
            }

            this.addPane = function (pane) {
                if (panes.length === 0) {
                    $scope.select(panes);
                }
                panes.push(pane);
            }
        }
    }
})();


// WEBPACK FOOTER //
// ./js/directives/component/bba-tabs/bba-tabs.js